import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmMicrophone = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-microphone",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-microphone",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      clipRule: "evenodd",
      d: "m12 1.7c-1.9 0-3.4 1.5-3.4 3.4v6c0 1.9 1.5 3.4 3.4 3.4s3.4-1.5 3.4-3.4v-6c0-1.9-1.5-3.4-3.4-3.4zm-5.1 3.4c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v6c0 2.8-2.3 5.1-5.1 5.1s-5.1-2.3-5.1-5.1zm6 15.4v3.5h-1.7v-3.5c-2.2-.2-4.2-1.2-5.8-2.7-1.8-1.8-2.8-4.2-2.8-6.7v-.9h1.7v.9c0 2 .8 4 2.3 5.5 1.4 1.4 3.4 2.3 5.4 2.3s4-.8 5.5-2.3c1.4-1.4 2.3-3.4 2.3-5.5v-.9h1.7v.9c0 2.5-1 4.9-2.8 6.7-1.6 1.6-3.7 2.5-5.8 2.7z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
});
IconLlmMicrophone.displayName = 'IconLlmMicrophone';

export { IconLlmMicrophone };
//# sourceMappingURL=llm-microphone.js.map
